export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_06.47e771b9.jpg";